import { axiosInstance } from '../api/axios.instance';
import { API_CONFIG } from '../api/config';
import { 
  ListarAlertasApiResponseSchema,
  transformAlertasApiToUi,
  AlertaUi 
} from '../schemas/alertas/listar-alertas';

export class AlertasService {
  static async listarAlertas(page: number = 1, limit: number = 25): Promise<{
    data: AlertaUi[];
    total: number;
    page: number;
    limit: number;
  }> {
    try {
      const params = new URLSearchParams();
      params.append('page', page.toString());
      params.append('limit', limit.toString());

      const response = await axiosInstance.get(
        `${API_CONFIG.ENDPOINTS.NOTIFICACIONES.LISTAR}?${params.toString()}`
      );
      
      const validatedResponse = ListarAlertasApiResponseSchema.parse(response.data);
      
      return {
        data: transformAlertasApiToUi(validatedResponse.data),
        total: validatedResponse.total,
        page: validatedResponse.page,
        limit: validatedResponse.limit
      };
    } catch (error) {
      console.error('Error al obtener alertas:', error);
      throw new Error('No se pudieron cargar las alertas');
    }
  }

  static async marcarComoVisualizada(alertaId: string): Promise<void> {
    try {
      await axiosInstance.post(API_CONFIG.ENDPOINTS.NOTIFICACIONES.MODIFICAR_ESTADO(alertaId));
    } catch (error) {
      console.error('Error al marcar alerta como visualizada:', error);
      throw new Error('No se pudo marcar la alerta como visualizada');
    }
  }
}